import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#C92042" }}>Highlights</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <p>
              Simple, user-friendly, and intuitive interface with informative
              and thorough features and functions for meaning and rewarding
              experience.
            </p>
            <p>
              Comprehensive real estate investment details including investment
              strategy, sponsor benefits, investor benefits, and insights and
              press release section that enhances user’s reading experience.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center mt-3"
          >
            <StaticImage
              src="../../../images/case-studies/murifield/highligts_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1032}
              height={839}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
